import { notification } from 'antd'
import { OTPAuthentication } from 'components/atoms'
import { useModal } from 'hooks'
import { IPatient } from 'pages/patientReceive/interfaces'
import { useRef } from 'react'
import { useTranslation } from 'react-i18next'
import { usePatientService } from 'services/usePatientService'

const useAddProfileByService = (callbackFinished?: () => void) => {
  const { requestAddProfile, requestOTPAddPatient, verifyOTPAddPatient } =
    usePatientService()
  const modal = useModal()
  const { t } = useTranslation()
  const requestRef = useRef('b430369f-18a0-4b93-b913-22ee9ff9fde4')

  const handleSubmit = async (otp: string) => {
    const res = await verifyOTPAddPatient(requestRef.current, otp)
    if (res?._successfully) {
      notification.success({ message: t('add-profile-success') })
      callbackFinished && callbackFinished()
      modal.close()
    }
  }

  const handleRequestAddProfile = async (patient: IPatient) => {
    const resAddProfile = await requestAddProfile(patient?.user_id)
    if (resAddProfile?.data?.request_id) {
      requestRef.current = resAddProfile?.data?.request_id
      const resOtp = await requestOTPAddPatient(resAddProfile?.data?.request_id)
      if (resOtp?._successfully) {
        modal.open(
          <OTPAuthentication
            timeCountDown={60}
            phoneNumber={patient?.phone_number}
            onSubmit={handleSubmit}
          />,
          {
            title: t('otp-authentication'),
            footer: null
          },
          () => {}
        )
      }
    }
  }
  return { requestAddProfile, handleRequestAddProfile }
}

export default useAddProfileByService
